import React from "react";

const TextInput = ({ term, setTerm, inputClasses, placeholder }) => {
  return <input type="text" value={term} onChange={(e) => setTerm(e.target.value)} className={inputClasses} placeholder={placeholder} />;
};

export default TextInput;
